var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con-tags-text"},_vm._l((_vm.post.tags),function(tag){return _c('span',{key:tag.id,staticClass:"pointer",on:{"click":function($event){return _vm.searchTag(tag.id, tag.tag)}}},[_vm._v(_vm._s(tag.tag))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }